import {
  BackgroundContainer,
  Container,
  Header,
  PpsLogo,
  PpsLogoJa,
  SubTitle,
  Title,
  IconWrapper,
  SignalWave,
} from "./LoginPageStyle";

import LoginForm from "../../components/Form/LoginForm";
import Seo from "../../components/Seo";
import { useTranslation } from "react-i18next";
import { getLocalStorageWithExpiry } from "../../locales/langFunc";
import { useState } from "react";
import { FaSatelliteDish } from "react-icons/fa";
import styled, { keyframes } from "styled-components";

const SatelliteWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const signalPulse = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.2;
  }
  50% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
`;

const Signal = styled.div`
  position: absolute;
  left: 35px; /* Adjust to position the signal near the satellite icon */
  display: flex;
  gap: 2px;
  height: 10px;

  /* Create the signal bars with increasing sizes */
  div {
    width: 2px;
    background-color: #007bff;
    opacity: 0.6;
    transform-origin: bottom;

    &:nth-child(1) {
      height: 4px;
      animation: ${signalPulse} 1.5s infinite;
    }

    &:nth-child(2) {
      height: 6px;
      animation: ${signalPulse} 1.5s infinite 0.2s;
    }

    &:nth-child(3) {
      height: 8px;
      animation: ${signalPulse} 1.5s infinite 0.4s;
    }
  }
`;

function SatelliteSignal() {
  return (
    <SatelliteWrapper>
      <FaSatelliteDish
        size={24}
        style={{
          marginRight: "10px",
          color: "#868e96", // Muted gray color for a more refined look
        }}
      />
      <Signal>
        <div></div>
        <div></div>
        <div></div>
      </Signal>
    </SatelliteWrapper>
  );
}

const lang = getLocalStorageWithExpiry("i18nextLng") || "en";

export default function LoginPage() {
  const { t } = useTranslation();
  const [isSignalActive, setIsSignalActive] = useState(false);

  const handleMouseEnter = () => {
    setIsSignalActive(true);

    // Remove signal animation after 2 seconds
    setTimeout(() => {
      setIsSignalActive(false);
    }, 2000);
  };

  return (
    <BackgroundContainer>
      <Container>
        <Seo title={t(`login`)} />
        <Header>
          {lang === "ja" ? <PpsLogoJa /> : <PpsLogo />}
          <SatelliteWrapper>
            <Title onMouseEnter={handleMouseEnter}>
              {t(`Welcome to LPGA`)}
              {isSignalActive && <SignalWave />}
            </Title>
          </SatelliteWrapper>
          <IconWrapper>
            <SatelliteWrapper onMouseEnter={handleMouseEnter}>
              <SatelliteSignal />
            </SatelliteWrapper>
            <SubTitle>
              {t(
                `LPGA is a real-time precise location monitoring system by PPSOLN`
              )}
            </SubTitle>
          </IconWrapper>
        </Header>
        <LoginForm />
      </Container>
    </BackgroundContainer>
  );
}
